import { forwardRef } from 'react'

interface ToolbarActionButtonProps {
  /** Icon rendered before the label, e.g. an <svg> or <img> */
  icon?: React.ReactNode
  /** Button text. Can include extra markup, e.g. a selected-count suffix. */
  label: React.ReactNode
  onClick?: () => void
  loading?: boolean
  loadingText?: string
  disabled?: boolean
  id?: string
  className?: string
}

/**
 * Reusable toolbar action button, styled to match the app's filter fields
 * (38px height, 6px radius, no hover/active color change). Used for actions
 * like "Bulk Products Update" and "Export Selected".
 */
const ToolbarActionButton = forwardRef<HTMLButtonElement, ToolbarActionButtonProps>(
  ({ icon, label, onClick, loading, loadingText = 'Loading...', disabled, id, className = '' }, ref) => {
    return (
      <button
        ref={ref}
        id={id}
        type='button'
        className={`btn btn-light padding_8px_allside toolbar-input-match no-hover-btn ${className}`}
        style={{ display: 'flex', alignItems: 'center', userSelect: 'none' }}
        disabled={disabled || loading}
        onClick={onClick}
      >
        {loading ? (
          <>
            <span className='indicator-progress' style={{ display: 'block' }}>
              <span className='spinner-border spinner-border-sm align-middle me-2'></span>
            </span>
            <span>{loadingText}</span>
          </>
        ) : (
          <span style={{ display: 'flex', alignItems: 'center' }}>
            {icon}
            {label}
          </span>
        )}
      </button>
    )
  }
)

export { ToolbarActionButton }
